import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {OptionLabelValue} from '../../../../types/internal/OptionLabelValue';
import {useLazyGetEventTypesForInfiniteScrollingQuery} from '../../../../redux/api/eventTypes';
import NEWListWithSearchFilter from '../../../common/filters/NEWListWithSearchFilter';

export const DocumentEventTypeFilter = ({activeFilters, handleFilterChange}: {
  activeFilters: OptionLabelValue[] | null,
  handleFilterChange: (values: OptionLabelValue[]) => void,
}) => {

  const [
    getEventTypes,
    {
      data,
      isLoading,
      isFetching,
      isUninitialized,
      originalArgs,
    },
  ] = useLazyGetEventTypesForInfiniteScrollingQuery();

  const [querySearch, setQuerySearch] = useState<string>('');
  const options: OptionLabelValue[] = useMemo(() => data?.results.map(el => ({
    label: el.name,
    value: el.uuid,
  })) || [], [data?.results]);

  const handleGetNext = useCallback(() => {
    getEventTypes({
      ...!!querySearch && {search_by_name: querySearch},
      page: (originalArgs?.page || 0) + 1,
      page_size: 15,
    });
  }, [getEventTypes, originalArgs?.page, querySearch]);

  useEffect(() => {
    getEventTypes({
      ...!!querySearch && {search_by_name: querySearch},
      page: 1,
      page_size: 15,
    });
  }, [getEventTypes, querySearch]);

  return (
    <NEWListWithSearchFilter
      getNext={handleGetNext}
      options={options}
      selectedOptions={activeFilters || []}
      setSelectedOptions={handleFilterChange}
      total={data?.count || 0}
      isLoadingOptions={isLoading || isFetching || isUninitialized}
      querySearch={querySearch}
      setQuerySearch={setQuerySearch}
    />
  );
};